<div class="public-campaign-page">
    <div class="form-container">
  
      <div class="form-header">
        <div class="form-icon">
          🐾
        </div>
  
        <h1>Formulario de campaña</h1>
  
        <p>
          Completa la siguiente información para registrar
          la participación en una campaña de esterilización
          con ABAQ.
        </p>
      </div>
  
      @if (submitted) {
  
        <div class="success-card">
  
          <div class="success-icon">
            ✓
          </div>
  
          <h2>
            ¡Formulario enviado correctamente!
          </h2>
  
          <p>
            Hemos recibido la información de la campaña.
            El equipo de ABAQ revisará los datos registrados.
          </p>
  
        </div>
  
      } @else {
  
        <form
          #campaignForm="ngForm"
          (ngSubmit)="submitForm()"
        >
  
          <!-- RESPONSABLE -->
  
          <section class="form-section">
  
            <div class="section-title">
              <h2>Información del responsable</h2>
  
              <p>
                Proporciona los datos de la persona responsable
                del animal.
              </p>
            </div>
  
            <div class="form-grid">
  
              <div class="form-group full-width">
  
                <label for="responsibleName">
                  Nombre completo *
                </label>
  
                <input
                  id="responsibleName"
                  type="text"
                  name="responsibleName"
                  [(ngModel)]="responsibleName"
                  placeholder="Nombre completo"
                  required
                />
  
              </div>
  
              <div class="form-group">
  
                <label for="responsibleAge">
                  Edad
                </label>
  
                <input
                  id="responsibleAge"
                  type="number"
                  name="responsibleAge"
                  [(ngModel)]="responsibleAge"
                  min="0"
                  placeholder="Edad"
                />
  
              </div>
  
              <div class="form-group">
  
                <label for="responsibleGender">
                  Género
                </label>
  
                <select
                  id="responsibleGender"
                  name="responsibleGender"
                  [(ngModel)]="responsibleGender"
                >
                  <option value="">
                    Selecciona una opción
                  </option>
  
                  <option value="F">
                    Femenino
                  </option>
  
                  <option value="M">
                    Masculino
                  </option>
  
                  <option value="OTHER">
                    Otro
                  </option>
                </select>
  
              </div>
  
            </div>
  
          </section>
  
  
          <!-- DOMICILIO -->
  
          <section class="form-section">
  
            <div class="section-title">
              <h2>Domicilio</h2>
  
              <p>
                Indica la ubicación del responsable.
              </p>
            </div>
  
            <div class="form-grid">
  
              <div class="form-group full-width">
  
                <label for="street">
                  Calle
                </label>
  
                <input
                  id="street"
                  type="text"
                  name="street"
                  [(ngModel)]="street"
                  placeholder="Calle y número"
                />
  
              </div>
  
              <div class="form-group">
  
                <label for="neighborhood">
                  Colonia
                </label>
  
                <input
                  id="neighborhood"
                  type="text"
                  name="neighborhood"
                  [(ngModel)]="neighborhood"
                  placeholder="Colonia"
                />
  
              </div>
  
              <div class="form-group">
  
                <label for="municipality">
                  Municipio
                </label>
  
                <input
                  id="municipality"
                  type="text"
                  name="municipality"
                  [(ngModel)]="municipality"
                  placeholder="Municipio"
                />
  
              </div>
  
            </div>
  
          </section>
  
  
          <!-- CONTACTO -->
  
          <section class="form-section">
  
            <div class="section-title">
              <h2>Información de contacto</h2>
  
              <p>
                Datos para poder comunicarnos contigo.
              </p>
            </div>
  
            <div class="form-grid">
  
              <div class="form-group">
  
                <label for="email">
                  Correo electrónico
                </label>
  
                <input
                  id="email"
                  type="email"
                  name="email"
                  [(ngModel)]="email"
                  placeholder="correo@ejemplo.com"
                />
  
              </div>
  
              <div class="form-group">
  
                <label for="phone">
                  Teléfono
                </label>
  
                <input
                  id="phone"
                  type="tel"
                  name="phone"
                  [(ngModel)]="phone"
                  placeholder="Número de teléfono"
                />
  
              </div>
  
              <div class="form-group full-width">
  
                <label for="payment">
                  Forma de pago
                </label>
  
                <input
                  id="payment"
                  type="text"
                  name="payment"
                  [(ngModel)]="payment"
                  placeholder="Forma de pago"
                />
  
              </div>
  
            </div>
  
          </section>
  
  
          <!-- ABAQ -->
  
          <section class="form-section">
  
            <div class="section-title">
              <h2>Información de ABAQ</h2>
  
              <p>
                Cuéntanos cómo conociste ABAQ y sobre tus
                redes sociales.
              </p>
            </div>
  
            <div class="form-grid">
  
              <div class="form-group full-width">
  
                <label for="howDidYouHearAboutAbaq">
                  ¿Cómo supiste de ABAQ?
                </label>
  
                <input
                  id="howDidYouHearAboutAbaq"
                  type="text"
                  name="howDidYouHearAboutAbaq"
                  [(ngModel)]="howDidYouHearAboutAbaq"
                  placeholder="Evento, redes, medios, referido..."
                />
  
              </div>
  
              <div class="form-group">
  
                <label for="socialNetwork">
                  Red social
                </label>
  
                <input
                  id="socialNetwork"
                  type="text"
                  name="socialNetwork"
                  [(ngModel)]="socialNetwork"
                  placeholder="Instagram, Facebook..."
                />
  
              </div>
  
              <div class="form-group">
  
                <label for="socialAccount">
                  Cuenta / usuario
                </label>
  
                <input
                  id="socialAccount"
                  type="text"
                  name="socialAccount"
                  [(ngModel)]="socialAccount"
                  placeholder="@usuario"
                />
  
              </div>
  
              <div class="checkbox-group full-width">
  
                <label class="checkbox-label">
  
                  <input
                    type="checkbox"
                    name="recommendedAbaqOnSocialMedia"
                    [(ngModel)]="recommendedAbaqOnSocialMedia"
                  />
  
                  <span>
                    Recomendaría a ABAQ en redes sociales
                  </span>
  
                </label>
  
              </div>
  
            </div>
  
          </section>
  
  
          <!-- ANIMAL -->
  
          <section class="form-section">
  
            <div class="section-title">
              <h2>Información del animal</h2>
  
              <p>
                Proporciona los datos del animal que participará
                en la campaña.
              </p>
            </div>
  
            <div class="form-grid">
  
              <div class="form-group">
  
                <label for="petName">
                  Nombre del animal *
                </label>
  
                <input
                  id="petName"
                  type="text"
                  name="petName"
                  [(ngModel)]="petName"
                  placeholder="Nombre del animal"
                  required
                />
  
              </div>
  
              <div class="form-group">
  
                <label for="species">
                  Especie *
                </label>
  
                <select
                  id="species"
                  name="species"
                  [(ngModel)]="species"
                  required
                >
                  <option value="DOG">
                    Perro
                  </option>
  
                  <option value="CAT">
                    Gato
                  </option>
                </select>
  
              </div>
  
              <div class="form-group">
  
                <label for="petGender">
                  Sexo
                </label>
  
                <select
                  id="petGender"
                  name="petGender"
                  [(ngModel)]="petGender"
                >
                  <option value="">
                    Selecciona una opción
                  </option>
  
                  <option value="M">
                    Macho
                  </option>
  
                  <option value="F">
                    Hembra
                  </option>
                </select>
  
              </div>
  
              <div class="form-group">
  
                <label for="breed">
                  Raza
                </label>
  
                <input
                  id="breed"
                  type="text"
                  name="breed"
                  [(ngModel)]="breed"
                  placeholder="Raza"
                />
  
              </div>
  
              <div class="form-group">
  
                <label for="size">
                  Tamaño
                </label>
  
                <select
                  id="size"
                  name="size"
                  [(ngModel)]="size"
                >
                  <option value="">
                    Selecciona una opción
                  </option>
  
                  <option value="SMALL">
                    Pequeño
                  </option>
  
                  <option value="MEDIUM">
                    Mediano
                  </option>
  
                  <option value="LARGE">
                    Grande
                  </option>
                </select>
  
              </div>
  
              <div class="form-group">
  
                <label for="petAge">
                  Edad
                </label>
  
                <input
                  id="petAge"
                  type="number"
                  name="petAge"
                  [(ngModel)]="petAge"
                  min="0"
                  placeholder="Edad"
                />
  
              </div>
  
              <div class="form-group">
  
                <label for="weight">
                  Peso (kg)
                </label>
  
                <input
                  id="weight"
                  type="number"
                  name="weight"
                  [(ngModel)]="weight"
                  min="0"
                  step="0.1"
                  placeholder="Peso"
                />
  
              </div>
  
            </div>
  
          </section>
  
  
          <!-- CAMPAÑA -->
  
          <section class="form-section">
  
            <div class="section-title">
              <h2>Información de la campaña</h2>
  
              <p>
                Información relacionada con la esterilización
                y la campaña.
              </p>
            </div>
  
            <div class="form-grid">
  
              <div class="form-group">
  
                <label for="sterilizationDate">
                  Fecha de esterilización
                </label>
  
                <input
                  id="sterilizationDate"
                  type="date"
                  name="sterilizationDate"
                  [(ngModel)]="sterilizationDate"
                />
  
              </div>
  
              <div class="form-group">
  
                <label for="sterilizationLocation">
                  Lugar de esterilización
                </label>
  
                <input
                  id="sterilizationLocation"
                  type="text"
                  name="sterilizationLocation"
                  [(ngModel)]="sterilizationLocation"
                  placeholder="Lugar"
                />
  
              </div>
  
              <div class="form-group">
  
                <label for="campaignType">
                  Tipo de campaña
                </label>
  
                <input
                  id="campaignType"
                  type="text"
                  name="campaignType"
                  [(ngModel)]="campaignType"
                  placeholder="Tipo de campaña"
                />
  
              </div>
  
              <div class="form-group">
  
                <label for="veterinarian">
                  Veterinario
                </label>
  
                <input
                  id="veterinarian"
                  type="text"
                  name="veterinarian"
                  [(ngModel)]="veterinarian"
                  placeholder="Nombre del veterinario"
                />
  
              </div>
  
              <div class="form-group full-width">
  
                <label for="comments">
                  Comentarios
                </label>
  
                <textarea
                  id="comments"
                  name="comments"
                  rows="4"
                  [(ngModel)]="comments"
                  placeholder="Agrega comentarios adicionales..."
                ></textarea>
  
              </div>
  
            </div>
  
          </section>
  
  
          <!-- SUBMIT -->
  
          <div class="form-actions">
  
            <button
              type="submit"
              class="submit-button"
              [disabled]="
                campaignForm.invalid ||
                isSubmitting
              "
            >
              @if (isSubmitting) {
                Enviando...
              } @else {
                Enviar formulario
              }
            </button>
  
          </div>
  
        </form>
  
      }
  
    </div>
  </div>